export default {
    "首页":"Beranda",
    "发展历史":"Sejarah Perkembangan",
    "资质荣誉":"Sertifikasi & Penghargaan",
    "宣传视频":"Video Promosi",
    "新闻资讯":"Berita & Informasi",
    "产品展示":"Tampilan Produk",
    "客户案例":"Kasus Pelanggan",
    "下载中心":"Pusat Unduhan",
    "联系我们":"Hubungi Kami",
    "公司":"Perusahaan",
    "联系人":"Kontak Person",
    "传真":"Faks",
    "邮件":"Email",
    "邮政编码":"Kode Pos",
    "网址":"Alamat Website",
    "地址":"Alamat",
    "在线留言":"Pesan Online",
    "标题":"Judul",
    "请填写标题":"Silakan isi judul",
    "姓名":"Nama",
    "请填写姓名":"Silakan isi nama Anda",
    "电话":"Telepon",
    "请填写电话":"Silakan isi nomor telepon Anda",
    "内容":"Konten",
    "请填写内容":"Silakan isi konten",
    "提交消息":"Kirim Pesan",
    "邮箱":"Kotak surat","来源":"Sumber",
    "创建时间":"Waktu Pembuatan",
    "点击量":"Jumlah Klik",
    "属于":"Milik",
    "上一条":"Sebelumnya",
    "下一条":"Berikutnya",
    "产品ID":"ID Produk",
    "购买价格":"Harga Pembelian",
    "发布时间":"Waktu Publikasi",
    "下载":"Unduh",
    "暂无下一条数据":"Tidak ada data berikutnya",
    "暂无上一条数据":"Tidak ada data sebelumnya",
    "登录":"Masuk",
}